import { render } from "./SelectCommand.vue?vue&type=template&id=0e5cf8b9"
import script from "./SelectCommand.vue?vue&type=script&lang=js"
export * from "./SelectCommand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__